import { EXECUTIONER } from '../cards/attack/executioner';
import { POWER_STRIKE } from '../cards/attack/power-strike';
import { VENOMBLADE } from '../cards/attack/venomblade';
import { ECHOES } from '../cards/recursive/echoes';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Epic tier: 4×3, 4 dice, optimal-vs-player AI.
 * Brutal optimiser — the epic AI sequences its big hits, holding Executioner for
 * a turn the dice fund 6+6 and pouring spare dice into Power Strike. The closest
 * thing to a damage race at epic; a test of your block tempo. Executioner is
 * rotated to a 2×1 column so the 2×2 Venomblade + three horizontals tile the
 * 4×3 grid. */
export const BONEREAPER: EnemyTemplate = {
  id: 'bonereaper',
  name: 'Bonereaper',
  glyph: '✟', // grave cross
  tier: 'epic',
  hp: 36,
  loadout: [
    { card: VENOMBLADE, origin: { row: 0, col: 0 }, rotated: false },
    { card: EXECUTIONER, origin: { row: 0, col: 2 }, rotated: true },
    { card: POWER_STRIKE, origin: { row: 2, col: 0 }, rotated: false },
    { card: ECHOES, origin: { row: 3, col: 0 }, rotated: false },
  ],
  drops: { gold: 20 },
};
